<template>
  <div class="b-table">
    <el-table ref="bTable" :data="tableData" v-bind="$attrs" v-on="$listeners" @selection-change="handleSelectionChange">
      <el-table-column
        v-if="multi"
        align="center"
        type="selection"
        width="55"
      />
      <el-table-column
        v-if="index"
        type="index"
        align="center"
        width="80"
        label="序号"
        :index="getIndex"
      />
      <slot />
    </el-table>
    <el-row v-if="pageSize > 0" type="flex" justify="end" class="page mt10">
      <el-pagination background :page-sizes="pagesList" :layout="layout" v-bind="pageInfo" :current-page.sync="pageInfo.pageNum" @size-change="handleSizeChange" @current-change="gotoPage" />
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'BTable',
  props: {
    // 分页配置, pageSize =0 时，则不分页
    pageSize: {
      type: Number,
      default: 10
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    // 是否开启多选
    multi: {
      type: Boolean,
      default: false
    },
    // 是否展现序号
    index: {
      type: Boolean,
      default: false
    },
    pagesList: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100, 200, 500];
      }
    },
    layout: {
      type: String,
      default() {
        return 'total, jumper, prev, pager, next';
      }
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tableData: [],
      pageInfo: {
        pageNum: 1,
        pageSize: this.pageSize || 10,
        total: 0
      }
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        console.log('b-table', newData);
        this.tableData = newData;
        this.pageInfo.total = this.total
      }
    }
  },
  methods: {
    // 跳转页面
    gotoPage: function(page) {
      this.pageInfo.pageNum = page;
      this.$emit('query', this.pageInfo);
    },

    handleSizeChange: function(val) {
      this.pageInfo.pageSize = val;
      this.$emit('query', this.pageInfo);
    },

    // 更新数据
    setData: function(pageData) {
      console.log(pageData,'0000')
      this.tableData = [].concat(pageData.list);
      this.pageInfo = Object.assign({}, pageData.pageInfo);
    },

    // 计算序列号
    getIndex(val) {
      return val + 1 + (this.pageInfo.pageNum - 1) * this.pageInfo.pageSize;
    },

    // 获取表格组件
    getWidget() {
      return this.$refs.bTable;
    },
    //选择
    handleSelectionChange(e) {
      console.log(e)
      this.$emit('handleSelectionChange', JSON.stringify(e))
    },

    //取消选择
    cancelSection() {
      this.$refs.bTable.clearSelection();
      this.$emit('handleSelectionChange', [])
    }
  }
};
</script>
